import React from 'react';
import { FiUsers, FiBookOpen, FiShield, FiClock, FiTrendingUp, FiAlertTriangle } from 'react-icons/fi';
import useAdminDashboard from './useAdminDashboard';
import {
  AdminDashboardContainer, WelcomeSection, WelcomeTitle, WelcomeSubtitle, QuickActionsGrid,
  QuickActionCard, QuickActionHeader, QuickActionIcon, QuickActionContent, QuickActionTitle,
  QuickActionDescription, StatsGrid, StatCard, StatHeader, StatIcon, StatContent, StatValue,
  StatLabel, FullWidthContainer, Section, SectionHeader, RecentActivityList, ActivityItem,
  ActivityIcon, ActivityContent, ActivityTitle, ActivityTime, EmptyState
} from './AdminDashboard.styles';

function AdminDashboard() {
  const { user, stats, quickActions, recentActivities, getActivityIcon } = useAdminDashboard();

  return (
    <AdminDashboardContainer>
      <WelcomeSection>
        <WelcomeTitle>
          السلام عليكم {user?.first_name}
        </WelcomeTitle>
        <WelcomeSubtitle>Welcome to the admin dashboard. Manage your system efficiently.</WelcomeSubtitle>
      </WelcomeSection>

      {/* Quick Actions */}
      <QuickActionsGrid>
        {quickActions.map((action, index) => (
          <QuickActionCard
            key={action.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0 }}
            onClick={action.onClick}
          >
            <QuickActionHeader>
              <QuickActionIcon $color={action.color}>
                {action.icon}
              </QuickActionIcon>
              <QuickActionContent>
                <QuickActionTitle>{action.title}</QuickActionTitle>
                <QuickActionDescription>{action.description}</QuickActionDescription>
              </QuickActionContent>
            </QuickActionHeader>
          </QuickActionCard>
        ))}
      </QuickActionsGrid>

      {/* Statistics */}
      <StatsGrid>
        <StatCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          <StatHeader>
            <StatIcon color="primary">
              <FiUsers size={20} />
            </StatIcon>
            <StatContent>
              <StatValue>{stats.totalUsers}</StatValue>
              <StatLabel>Total Users</StatLabel>
            </StatContent>
          </StatHeader>
        </StatCard>

        <StatCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
        >
          <StatHeader>
            <StatIcon color="success">
              <FiBookOpen size={20} />
            </StatIcon>
            <StatContent>
              <StatValue>{stats.totalCourses}</StatValue>
              <StatLabel>Total Courses</StatLabel>
            </StatContent>
          </StatHeader>
        </StatCard>

        <StatCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }}
        >
          <StatHeader>
            <StatIcon color="info">
              <FiShield size={20} />
            </StatIcon>
            <StatContent>
              <StatValue>{stats.totalInstructors}</StatValue>
              <StatLabel>Instructors</StatLabel>
            </StatContent>
          </StatHeader>
        </StatCard>

        <StatCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.4 }}
        >
          <StatHeader>
            <StatIcon color="warning">
              <FiTrendingUp size={20} />
            </StatIcon>
            <StatContent>
              <StatValue>{stats.totalStudents}</StatValue>
              <StatLabel>Students</StatLabel>
            </StatContent>
          </StatHeader>
        </StatCard>

        <StatCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.5 }}
        >
          <StatHeader>
            <StatIcon color="info">
              <FiClock size={20} />
            </StatIcon>
            <StatContent>
              <StatValue>{stats.activeSessions}</StatValue>
              <StatLabel>Active Sessions</StatLabel>
            </StatContent>
          </StatHeader>
        </StatCard>

        <StatCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.6 }}
        >
          <StatHeader>
            <StatIcon color="danger">
              <FiAlertTriangle size={20} />
            </StatIcon>
            <StatContent>
              <StatValue>{stats.pendingApprovals}</StatValue>
              <StatLabel>Pending Approvals</StatLabel>
            </StatContent>
          </StatHeader>
        </StatCard>
      </StatsGrid>

      {/* Recent Activity */}
      <FullWidthContainer>
        <Section>
          <SectionHeader>
            <h2>
              <FiClock size={20} />
              Recent Activity
            </h2>
          </SectionHeader>
          <RecentActivityList>
            {recentActivities.length > 0 ? (
              recentActivities.map((activity, index) => (
                <ActivityItem key={activity.id}>
                  <ActivityIcon>
                    {getActivityIcon(activity.type)}
                  </ActivityIcon>
                  <ActivityContent>
                    <ActivityTitle>{activity.title}</ActivityTitle>
                    <ActivityTime>{activity.time}</ActivityTime>
                  </ActivityContent>
                </ActivityItem>
              ))
            ) : (
              <EmptyState>
                <FiClock />
                <p>No recent activity.</p>
              </EmptyState>
            )}
          </RecentActivityList>
        </Section>
      </FullWidthContainer>
    </AdminDashboardContainer>
  );
}

export default AdminDashboard;
